/**
 * generateQrUrl — Build the mobile handoff URL for the QR code.
 *
 * Preserves all query params (color, view, preset, campaign, mode, etc.) so
 * the mobile session starts in the same state as the desktop session.
 *
 * @see docs/ims-brand-frontends/06-url-routing.md#qr-url-generation
 */

export function generateQrUrl(): string {
  return window.location.href;
}
